import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import image from "_assets/images/PRM-Logo-PNG/faq.png";
import { useMediaQuery } from 'react-responsive'

const FAQ = () => {
    const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })


    if(!isPhone){return (
        <>
          <Container>
            <Row>
              <div style={{marginLeft:-100}}>
                <img
                  src={image}
                  height={500}
                />
              </div>
            </Row>
          </Container>      
        </>
    );}
    else {
        return (
            <>
            <Container>
              <Row>
                <div style={{marginLeft:-15}}>
                  <img
                    src={image}
                    height={400}
                    
                  />
                </div>
              </Row>
            </Container>      
          </>
        )
    }
};

export default FAQ;
